/** Capitalization. Pluralization lives in @federa/const/count-noun (`countNoun`); SINGULARIZATION is not its sibling and never was -- the only singularizer in the tree is `singularizeTableName` (@federa/utils/compliance/rule-helpers/singularize-table-name), a D1 table-name helper, so a caller sent here for one arrived at a leaf that has never carried it. Kebab-case and the snake_case humanizer are in @federa/const/string-case. Workers-compatible; the narrow isNonEmptyString predicate comes from a `@federa/const` pure leaf (utils one-way floor). */

import { isNonEmptyString } from '@federa/const/string-guards';
import { upperFirst } from '@federa/const/string-case';

/** {@link upperFirst} behind a blank guard: '' for blank or nullish input; the rest of the string is untouched. */
export function capitalizeFirst(str: string): string {
	if (!isNonEmptyString(str)) return '';
	return upperFirst(str);
}
